import { type PropsWithChildren } from 'react'
import styled from 'styled-components'

/**
 * Used to add hidden content to the DOM to benefit SEO crawlers.
 */
export const BotOnly = ({ children }: PropsWithChildren) => {
  return <HiddenContent data-bot-only="true">{children}</HiddenContent>
}

const HiddenContent = styled.div`
  display: none;
`
